import { render, staticRenderFns } from "./SubmitAgreement.vue?vue&type=template&id=56199780&scoped=true&"
import script from "./SubmitAgreement.vue?vue&type=script&lang=js&"
export * from "./SubmitAgreement.vue?vue&type=script&lang=js&"
import style0 from "./SubmitAgreement.vue?vue&type=style&index=0&id=56199780&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56199780",
  null
  
)

export default component.exports